import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { empty, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DefaultService } from '../../../core/framework/default-service';
import { ErrorHandlerService } from '../../../core/framework/error-handler.service';
import { InterceptorPreLogin } from '../../../core/framework/http-interceptor-prelogin';
import { CatalogoUsuario } from './model/catalogo-usuario.model';
import { CatalogoUsuarioFilter } from './model/catalogo-usuario.filter';

@Injectable({
  providedIn: 'root'
})
export class CatalogoUsuarioService extends DefaultService<CatalogoUsuario> {

  static URL = '/api/multitenancy/catalogo_usuario/v1/catalogo_usuario';

  constructor(
    public httpClient: HttpClient,
    public errorHandlerService: ErrorHandlerService
  ) {
    super(httpClient, 
          errorHandlerService, 
          CatalogoUsuarioService.URL);
  }

  existeNoCatalogo(filtro: CatalogoUsuarioFilter): Observable<any> {
    const url = CatalogoUsuarioService.URL + '/existeNoCatalogo';
    const params = DefaultService.converterFiltroParaHttpParam(filtro);
    params.append(InterceptorPreLogin, '');
    const httpOptions = {
      headers: new HttpHeaders({}).append(InterceptorPreLogin, ''),
      params: params
    };

    return this.httpClient.get<boolean>(url, httpOptions)
               .pipe(
                  map( emailValido => {
                    return emailValido;
                  })
                  , catchError( err => throwError(this.errorHandlerService.handle(err)) )
               );
  }

  buscarPorUidETenantAtivo(uid: string): Observable<CatalogoUsuario> {
    return this.httpClient.get<CatalogoUsuario>(CatalogoUsuarioService.URL + '/buscarPorUidETenantAtivo?uid=' + uid, this.httpOptions)
               .pipe(
                  catchError( err => throwError(this.errorHandlerService.handle(err)) )
               );
  }

  pesquisar(filter: CatalogoUsuarioFilter): Observable<CatalogoUsuario> {
    const params = DefaultService.converterFiltroParaHttpParam(filter);
    return this.httpClient.get<CatalogoUsuario>(CatalogoUsuarioService.URL + '/pesquisar', {params})
               .pipe(
                  catchError( err => throwError(err))
               );
  }

}
